import { PrioritisationConfig, createDefaultPrioritisationConfig } from '../models/prioritisation-config';

export class GetPrioritisationConfig {
  static prioritisationConfig: PrioritisationConfig[] = [createDefaultPrioritisationConfig()];
}
